import { Model } from 'shared/services/api/models/Model'
import { OrderLineItemsResponseItemV1 } from './ordersResponseTypes'
import { OrderLineItemsResponseItem } from 'shared/services/api/models/orders/orderLineItemsResponseItem'

export class OrderLineItemsResponse extends Model {
  public orderLineItemsResponse: OrderLineItemsResponseItemV1[]

  constructor(src: OrderLineItemsResponseItemV1[]) {
    super(src)

    this.orderLineItemsResponse = Array.isArray(src)
      ? src.map(
          (orderLineResponseItem: OrderLineItemsResponseItemV1) =>
            new OrderLineItemsResponseItem(orderLineResponseItem)
        )
      : []
  }
}
